import styled from 'styled-components';
import { OLAF } from 'HubStyleTokens/colors';
import H5 from 'UIComponents/elements/headings/H5';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIOverlay from 'UIComponents/overlay/UIOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoadingWrapper = styled.div.withConfig({
  displayName: "LoadingOverlayWithMessage__LoadingWrapper",
  componentId: "w6ozu6-0"
})(["height:100%;"]);
const Loading = styled.div.withConfig({
  displayName: "LoadingOverlayWithMessage__Loading",
  componentId: "w6ozu6-1"
})(["height:50px;"]);
const LoadingLabel = styled(H5).withConfig({
  displayName: "LoadingOverlayWithMessage__LoadingLabel",
  componentId: "w6ozu6-2"
})(["color:", ";text-align:center;"], OLAF);
const LoadingOverlayWithMessage = ({
  message
}) => {
  return /*#__PURE__*/_jsx(UIOverlay, {
    use: "dark",
    children: /*#__PURE__*/_jsxs(LoadingWrapper, {
      className: "flex-column justify-center",
      children: [/*#__PURE__*/_jsx(Loading, {
        children: /*#__PURE__*/_jsx(UILoadingSpinner, {
          grow: true
        })
      }), /*#__PURE__*/_jsx(LoadingLabel, {
        children: message
      })]
    })
  });
};
export default LoadingOverlayWithMessage;